import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import BusinessIcon from '@material-ui/icons/Business';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ContactsIcon from '@material-ui/icons/Contacts';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import WarningIcon from '@material-ui/icons/Warning';
import GrainIcon from '@material-ui/icons/Grain';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import CloudIcon from '@material-ui/icons/Cloud';
import GroupIcon from '@material-ui/icons/Group';
import SecurityIcon from '@material-ui/icons/Security';
import React from 'react';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';

export interface GroupMenuPros {
  group: string;
  items: Array<{
    title: string;
    icon: React.ReactElement;
    link: string;
    current?: boolean;
    key: string | boolean;
    disable?: boolean;
  }>;
}

export const listItems = (
  companySelected: CompanyData | null,
  role?: RolesEnum
): GroupMenuPros[] => {
  const menuGroupCompanySelected = [
    {
      group: 'Dashboards',
      items: [
        {
          title: 'LIST_PARTNER_DASHBOARD',
          icon: <GroupWorkIcon />,
          link: '/dashboard/partner',
          key: 'list_partner_dashboard',
        },
      ],
    },
    {
      group: 'SIDEBAR.MANAGEMENT_KEY',
      items: [
        {
          title: 'SIDEBAR.PARTNERS_LIST_KEY',
          icon: <AllInboxIcon />,
          link: '/partners',
          key: 'list_all_partners',
        },
        {
          title: 'SIDEBAR.ENVIRONMENTS_LIST_KEY',
          icon: <CloudIcon />,
          link: '/environments',
          key: 'list_environment',
        },
        {
          title: 'SIDEBAR.CLIENTS_LIST_KEY',
          icon: <AccountTreeIcon />,
          link: '/clients',
          key: 'list_client',
        },
        {
          title: 'LIST_USERS',
          icon: <GroupIcon />,
          link: '/users',
          key: 'list_all_users',
        },
      ],
    },
    {
      group: 'SIDEBAR.OPERATORS_AND_PERMISSIONS_KEY',
      items: [
        {
          title: 'SIDEBAR.OPERATORS_LIST_KEY',
          icon: <ContactsIcon />,
          link: '/operators',
          key: 'list_all_operators',
        },
        {
          title: 'SIDEBAR.GROUPS_LIST_KEY',
          icon: <SecurityIcon />,
          link: '/groups',
          key: 'list_all_roles',
        },
      ],
    },
  ];
  const menuGroupSuperAdmin = [
    {
      group: 'ADMINISTRATION_KEY',
      items: [
        {
          title: 'LIST_ALL_MENU.LIST_ALL_COMPANIES_KEY',
          icon: <BusinessIcon />,
          link: '/all-companies',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_PARTNERS_KEY',
          icon: <AllInboxIcon />,
          link: '/all-partners',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_ENVIRONMENTS_KEY',
          icon: <CloudIcon />,
          link: '/all-environments',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_CLIENTS_KEY',
          icon: <AccountTreeIcon />,
          link: '/all-clients',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_USERS_KEY',
          icon: <GroupIcon />,
          link: '/all-users',
          key: 'list_all_users',
        },
        {
          title: 'LOGS_PAGE.LIST_LOGS_KEY',
          icon: <GrainIcon />,
          link: '/audit',
          key: 'list_all_operators_audit_logs',
        },
        {
          title: 'LEAKED_CREDENTIALS_KEY',
          icon: <AssignmentIndIcon />,
          link: '/leaked-credentials',
          key: 'list_leaked_credentials',
        },
      ],
    },
    {
      group: 'Dashboards',
      items: [
        {
          title: 'LIST_ENVIRONMENT_INCIDENTS',
          icon: <WarningIcon />,
          link: '/dashboard/incidents',
          key: 'list_all_companies',
        },
        {
          title: 'SIDEBAR.OPTIMIZATION_DASHBOARD_KEY',
          icon: <DashboardIcon />,
          link: '/dashboard/advisors',
          key: 'list_scaling_advisors',
        },
        {
          title: 'COSTS_PAGE.DASHBOARD_TITLE_KEY',
          icon: <AttachMoneyIcon />,
          link: '/dashboard/costs',
          key: 'list_environment_cost',
        },
      ],
    },
    {
      group: 'SIDEBAR.OPERATORS_AND_PERMISSIONS_KEY',
      items: [
        {
          title: 'SIDEBAR.OPERATORS_LIST_KEY',
          icon: <ContactsIcon />,
          link: '/operators',
          key: 'list_all_operators',
        },
        {
          title: 'SIDEBAR.GROUPS_LIST_KEY',
          icon: <SecurityIcon />,
          link: '/groups',
          key: 'list_all_roles',
        },
      ],
    },
  ];

  const menuGroupAdmin = [
    {
      group: 'ADMINISTRATION_KEY',
      items: [
        {
          title: 'LIST_ALL_MENU.LIST_ALL_COMPANIES_KEY',
          icon: <BusinessIcon />,
          link: '/all-companies',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_PARTNERS_KEY',
          icon: <AllInboxIcon />,
          link: '/all-partners',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_ENVIRONMENTS_KEY',
          icon: <CloudIcon />,
          link: '/all-environments',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_CLIENTS_KEY',
          icon: <AccountTreeIcon />,
          link: '/all-clients',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_USERS_KEY',
          icon: <GroupIcon />,
          link: '/all-users',
          key: 'list_all_users',
        },
        {
          title: 'LOGS_PAGE.LIST_LOGS_KEY',
          icon: <GrainIcon />,
          link: '/audit',
          key: 'list_all_operators_audit_logs',
        },
      ],
    },
    {
      group: 'Dashboards',
      items: [
        {
          title: 'LIST_ENVIRONMENT_INCIDENTS',
          icon: <WarningIcon />,
          link: '/dashboard/incidents',
          key: 'list_all_companies',
        },
        {
          title: 'SIDEBAR.OPTIMIZATION_DASHBOARD_KEY',
          icon: <DashboardIcon />,
          link: '/dashboard/advisors',
          key: 'list_scaling_advisors',
        },
      ],
    },
    {
      group: 'SIDEBAR.OPERATORS_AND_PERMISSIONS_KEY',
      items: [
        {
          title: 'SIDEBAR.OPERATORS_LIST_KEY',
          icon: <ContactsIcon />,
          link: '/operators',
          key: 'list_all_operators',
        },
        {
          title: 'SIDEBAR.GROUPS_LIST_KEY',
          icon: <SecurityIcon />,
          link: '/groups',
          key: 'list_all_roles',
        },
      ],
    },
  ];
  const menuGroupOperator = [
    {
      group: 'ADMINISTRATION_KEY',
      items: [
        {
          title: 'LIST_ALL_MENU.LIST_ALL_COMPANIES_KEY',
          icon: <BusinessIcon />,
          link: '/all-companies',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_PARTNERS_KEY',
          icon: <AllInboxIcon />,
          link: '/all-partners',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_ENVIRONMENTS_KEY',
          icon: <CloudIcon />,
          link: '/all-environments',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_CLIENTS_KEY',
          icon: <AccountTreeIcon />,
          link: '/all-clients',
          key: 'list_all_companies',
        },
        {
          title: 'LIST_ALL_MENU.LIST_ALL_USERS_KEY',
          icon: <GroupIcon />,
          link: '/all-users',
          key: 'list_all_users',
        },
        {
          title: 'LOGS_PAGE.LIST_LOGS_KEY',
          icon: <GrainIcon />,
          link: '/audit',
          key: 'list_all_operators_audit_logs',
        },
      ],
    },
    {
      group: 'Dashboards',
      items: [
        {
          title: 'LIST_ENVIRONMENT_INCIDENTS',
          icon: <WarningIcon />,
          link: '/dashboard/incidents',
          key: 'list_all_companies',
        },
      ],
    },
    {
      group: 'SIDEBAR.OPERATORS_AND_PERMISSIONS_KEY',
      items: [
        {
          title: 'SIDEBAR.OPERATORS_LIST_KEY',
          icon: <ContactsIcon />,
          link: '/operators',
          key: 'list_all_operators',
        },
        {
          title: 'SIDEBAR.GROUPS_LIST_KEY',
          icon: <SecurityIcon />,
          link: '/groups',
          key: 'list_all_roles',
        },
      ],
    },
  ];
  const menuGroupClientOperator = [
    {
      group: 'Dashboards',
      items: [
        {
          title: 'LIST_PARTNER_DASHBOARD',
          icon: <GroupWorkIcon />,
          link: '/dashboard/partner',
          key: 'list_partner_dashboard',
        },
      ],
    },
    {
      group: 'SIDEBAR.MANAGEMENT_KEY',
      items: [
        {
          title: 'SIDEBAR.PARTNERS_LIST_KEY',
          icon: <AllInboxIcon />,
          link: '/partners',
          key: 'list_all_partners',
        },
        {
          title: 'SIDEBAR.ENVIRONMENTS_LIST_KEY',
          icon: <CloudIcon />,
          link: '/environments',
          key: 'list_environment',
        },
        {
          title: 'SIDEBAR.CLIENTS_LIST_KEY',
          icon: <AccountTreeIcon />,
          link: '/clients',
          key: 'list_client',
        },
        {
          title: 'LIST_USERS',
          icon: <GroupIcon />,
          link: '/users',
          key: 'list_all_users',
        },
      ],
    },
  ];

  const menuOptions = () => {
    if (!companySelected && role === RolesEnum.superAdmin) {
      return menuGroupSuperAdmin;
    }
    if (!companySelected && role === RolesEnum.admin) {
      return menuGroupAdmin;
    }
    if (!companySelected && role === RolesEnum.operator) {
      return menuGroupOperator;
    }
    if (role === RolesEnum.clientOperator) {
      return menuGroupClientOperator;
    }
    return menuGroupCompanySelected;
  };

  return menuOptions();
};
export default listItems;
